import { createSelector, MemoizedSelector } from '@ngrx/store';
import { encodeUid } from '@shared/helpers';
import { ProductReference, StateUtils } from '@spartacus/core';
import { ProductState, StateWithProduct } from '../product-state';
import { getCustomProductState } from './feature.selector';

type ProductGroupReferencesState = ProductState['productGroupReferences'];

export const getProductGroupReferencesState: MemoizedSelector<StateWithProduct, ProductGroupReferencesState> =
  createSelector(getCustomProductState, (state: ProductState) => state.productGroupReferences);

export const getProductGroupReferences = (
  productCode: string,
  referenceType: string,
  categoryCode: string,
): MemoizedSelector<StateWithProduct, StateUtils.LoaderState<ProductReference[]>> =>
  createSelector(getProductGroupReferencesState, (state: ProductGroupReferencesState) =>
    StateUtils.entityLoaderStateSelector<ProductReference[]>(
      state,
      encodeUid(productCode, referenceType, categoryCode),
    ),
  );

export const getProductGroupReferencesValue = (
  productCode: string,
  referenceType: string,
  categoryCode: string,
): MemoizedSelector<StateWithProduct, ProductReference[]> =>
  createSelector(getProductGroupReferencesState, (state: ProductGroupReferencesState) =>
    StateUtils.entityValueSelector<ProductReference[]>(state, encodeUid(productCode, referenceType, categoryCode)),
  );

export const getProductGroupReferencesLoading = (
  productCode: string,
  referenceType: string,
  categoryCode: string,
): MemoizedSelector<StateWithProduct, boolean> =>
  createSelector(getProductGroupReferencesState, (state: ProductGroupReferencesState) =>
    StateUtils.entityLoadingSelector<ProductReference[]>(state, encodeUid(productCode, referenceType, categoryCode)),
  );

export const getProductGroupReferencesError = (
  productCode: string,
  referenceType: string,
  categoryCode: string,
): MemoizedSelector<StateWithProduct, boolean> =>
  createSelector(getProductGroupReferencesState, (state: ProductGroupReferencesState) =>
    StateUtils.entityErrorSelector<ProductReference[]>(state, encodeUid(productCode, referenceType, categoryCode)),
  );

export const getProductGroupReferencesSuccess = (
  productCode: string,
  referenceType: string,
  categoryCode: string,
): MemoizedSelector<StateWithProduct, boolean> =>
  createSelector(getProductGroupReferencesState, (state: ProductGroupReferencesState) =>
    StateUtils.entitySuccessSelector<ProductReference[]>(state, encodeUid(productCode, referenceType, categoryCode)),
  );
